import { render, staticRenderFns } from "./UsersPrivilegeSurgriesHistory.vue?vue&type=template&id=ffa76c9a&scoped=true&"
import script from "./UsersPrivilegeSurgriesHistory.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegeSurgriesHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa76c9a",
  null
  
)

export default component.exports